import {PortalType} from "@studyportals/domain-client";
import {defineNuxtRouteMiddleware, navigateTo, useRuntimeConfig} from "nuxt/app";
import type {RouteLocationNormalized} from "vue-router"
import {isCatchAllRoute} from "@utils/route-helpers";
import {FilterType} from "@studyportals/omnisearch-interfaces";
import {AttendanceFilterValue} from "@studyportals/search-api-interface"; // TODO: Remove before production release
import { programmePortalTypeBasePaths, universityPortalTypeBasePaths } from "@app/utils/portal-type-base-path";
import { ROUTE_PREFIX } from "@generator/config/route-prefix";

export default defineNuxtRouteMiddleware((to: RouteLocationNormalized) => {
	if (import.meta.client) return;


	if (!isCatchAllRoute(to) && to.params[FilterType.EDUCATION_LEVEL] === undefined) return;

	const matchedPortalType = useRuntimeConfig().public.portalType as PortalType;
	const matchedProgrammePortalTypeBasePath = matchedPortalType ? programmePortalTypeBasePaths[matchedPortalType] : null;
	const matchedUniversityPortalTypeBasePath = matchedPortalType ? universityPortalTypeBasePaths[matchedPortalType] : null;
	const originalProgrammePortalTypeBasePath = matchedProgrammePortalTypeBasePath?.replace(ROUTE_PREFIX, '') ?? null;
	const originalUniversityPortalTypeBasePath = matchedUniversityPortalTypeBasePath?.replace(ROUTE_PREFIX, '') ?? null;

	if (!matchedProgrammePortalTypeBasePath) return;

	if(!matchedUniversityPortalTypeBasePath ) return;

	if(matchedPortalType !== PortalType.DISTANCE_LEARNING &&
		(
			to.path.startsWith(matchedProgrammePortalTypeBasePath) ||
			to.path.startsWith(matchedUniversityPortalTypeBasePath) ||
			(originalProgrammePortalTypeBasePath !== null && to.path.startsWith(originalProgrammePortalTypeBasePath)) ||
			(originalUniversityPortalTypeBasePath !== null && to.path.startsWith(originalUniversityPortalTypeBasePath))
		)
	) {
		return;
	}

	const query = { ...to.query };
	const params = to.params;

	if (matchedPortalType === PortalType.DISTANCE_LEARNING ) {
		const routePortalValue = params[FilterType.EDUCATION_LEVEL];
		const hasLegacyPortalParam = typeof routePortalValue === 'string' && routePortalValue !== 'distance-learning';
		const hasLvQuery = typeof query[FilterType.EDUCATION_LEVEL] === 'string' && query[FilterType.EDUCATION_LEVEL].length > 0;

		if (hasLegacyPortalParam && !hasLvQuery) {
			query[FilterType.EDUCATION_LEVEL] = routePortalValue;
		}

		const attendanceValue = String(query[FilterType.ATTENDANCE] || '');
		const hasOnline = attendanceValue.includes(AttendanceFilterValue.ONLINE);
		const hasBlended = attendanceValue.includes(AttendanceFilterValue.BLENDED);
		const hasOnlineOnly = query[FilterType.ATTENDANCE] === AttendanceFilterValue.ONLINE || params[FilterType.ATTENDANCE] === AttendanceFilterValue.ONLINE;
		const isOnDistanceLearningBasePath = to.path.startsWith(matchedProgrammePortalTypeBasePath) || to.path.startsWith(matchedUniversityPortalTypeBasePath);

		if (isOnDistanceLearningBasePath && hasOnline && hasBlended && !hasLegacyPortalParam) return;
		if (isOnDistanceLearningBasePath && hasOnlineOnly && !hasLegacyPortalParam) return;

		if (!hasOnlineOnly && (!hasOnline || !hasBlended)) {
			query[FilterType.ATTENDANCE] = [AttendanceFilterValue.ONLINE, AttendanceFilterValue.BLENDED].join(',');
		}
	}

	if(originalUniversityPortalTypeBasePath !== null && to.path.startsWith(originalUniversityPortalTypeBasePath)) {
		return navigateTo({ path: `${matchedUniversityPortalTypeBasePath}${to.path.slice(originalUniversityPortalTypeBasePath.length)}`, query }, { redirectCode: 301 });
	}

	if(originalProgrammePortalTypeBasePath !== null && to.path.startsWith(originalProgrammePortalTypeBasePath)) {
		return navigateTo({ path: `${matchedProgrammePortalTypeBasePath}${to.path.slice(originalProgrammePortalTypeBasePath.length)}`, query }, { redirectCode: 301 });
	}

	return navigateTo({path: matchedProgrammePortalTypeBasePath, query}, {redirectCode: 301});
});
